import { useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import draftToMarkdown from 'draftjs-to-markdown'
import './../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { useTheme } from '@material-ui/core';
const ControllerEditor = (props) => {

    const theme = useTheme()
    const {
        content = '<p style="text-align:center;"><strong>Hola escribe a qui tu texto</strong></p>',
        onValue,
        height = "400px",
        onValuePlan = () => { }
    } = props
    const blocksFromHtml = htmlToDraft(content);
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    const [editorState, setEditorState] = useState(EditorState.createWithContent(contentState))

    const changeEditor = (EditorState) => {
        onValuePlan(draftToMarkdown(convertToRaw(editorState.getCurrentContent())))
        onValue(draftToHtml(convertToRaw(EditorState.getCurrentContent())))
        setEditorState(EditorState)
    }

    return (
        <div>
            <Editor
                editorState={editorState}
                toolbarClassName="demo-toolbar-custom"
                wrapperClassName="demo-wrapper"
                editorClassName="demo-editor-custom"
                toolbarStyle={{
                    border: `1px solid ${theme.palette.primary.main}`,
                }}
                editorStyle={{
                    minHeight: height,
                    maxHeight: height,
                    overflowY: "scroll",
                    border: `1px solid ${theme.palette.primary.main}`,
                    padding: "0px 5px"
                }}
                onEditorStateChange={changeEditor}
            />
        </div>
    )
}
export default ControllerEditor